module.exports = __webpack_public_path__ + "img/product.99b4df3e.png";